import React from 'react';
import { Modal, Box, Typography, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddFulfillmentCenters from './AddFulfillmentCenters';

const FulfillmentCenterList = ({ open, onClose, ...handlers }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: '90%',
          maxWidth: 1000,
          maxHeight: '90vh',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          m: '5% auto',
          p: 4,
          position: 'relative',
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 16, right: 16 }}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" fontWeight={600} mb={2}>
          Manage Fulfillment Centers
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <AddFulfillmentCenters {...handlers} />
      </Box>
    </Modal>
  );
};

export default FulfillmentCenterList;